export function getTextBefore(text: string, endText: string, inclusive = true) {
  const endIndex = text.indexOf(endText);
  if (endIndex < 0) {
    return text;
  }

  const toIndex = inclusive ? endIndex + endText.length : endIndex;
  return text.substring(0, toIndex);
}

export function getTextAfter(
  text: string,
  startText: string,
  inclusive = true,
) {
  const startIndex = text.indexOf(startText);
  if (startIndex < 0) {
    return '';
  }

  const fromIndex = inclusive ? startIndex : startIndex + startText.length;
  return text.substring(fromIndex);
}

export function getTextBetween(
  text: string,
  startText: string,
  endText: string,
  inclusive = true,
) {
  const result = [];
  let textAfter = '';

  while (text.indexOf(startText) >= 0 && text.indexOf(endText) >= 0) {
    textAfter = getTextAfter(text, startText);
    if (textAfter.indexOf(endText) > -1) {
      const textAfterStopIndex = inclusive
        ? textAfter.indexOf(endText) + endText.length
        : textAfter.indexOf(endText);

      const fromIndex = inclusive
        ? text.indexOf(startText)
        : text.indexOf(startText) + startText.length;

      const toIndex = fromIndex + textAfterStopIndex;

      const match = text.substring(fromIndex, toIndex);
      result.push(match);

      text = text.substring(toIndex);
    }
  }

  return result;
}
